import axios from 'axios';

export default axios.create({
    // baseURL: 'agl44:8182/lleln',
    baseURL: window.appUrl.ELN
});

export const serverUrl = () => {
         //return 'http://localhost:8185/lleln'
         return window.appUrl.ELN

   // return window.location.origin + '/methodSetup'
  // return 'http://AGL62:8181/methodSetup'

}